import { FC, JSX, useEffect, useState } from "react";
import "./Subscriptions.scss";
import MasterPage from "../../MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { usePaginate } from "../../../providers/PaginateProvider";
import { useSubscriptions } from "../../../providers/Financial/Subscriptions/SubscriptionsProvider";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";
import SidebarSubscriptionsFilter from "../../../components/Financial/Subscriptions/SidebarSubscriptionsFilter/SidebarSubscriptionsFilter";
import moment from "moment";
import FormatMoney from "../../../utils/FormatMoney";
import RenderMethodIcon from "../../../utils/RenderMethodIcon";
import ModalSubscriptionView from "../../../components/Financial/Subscriptions/ModalSubscriptionView/ModalSubscriptionView";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

interface SubscriptionsProps { }

const Subscriptions: FC<SubscriptionsProps> = () => {
  const {
    pages,
    subscriptions,
    params,
    setParams,
    isLoading,
    error,
  } = useSubscriptions();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();
  const [showModalView, setShowModalView] = useState<boolean>(false);
  const [selectedSubscription, setSelectedSubscription] = useState<any>(null);

  const handleView = (subscription: any) => {
    setSelectedSubscription(subscription);
    setShowModalView(true);
  };

  const handleCloseModal = () => {
    setSelectedSubscription(null);
    setShowModalView(false);
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {subscriptions?.length > 0 ? (
          <>
            {subscriptions.map((x: any) => {
              const lastPayment = x?.payments?.length > 0
                ? x.payments[x.payments.length - 1]
                : null;

              return (
                <tr key={x.id} className="text-sm">
                  <td className="text-center">{x.id}</td>
                  <td>{x?.user?.partner_code} - {x?.user?.name}</td>
                  <td>{x?.plan?.name}</td>
                  <td className="text-center">
                    {x?.cycle === "annual" ? "Anual" : "Mensal"}
                  </td>

                  <td>
                    {lastPayment
                      ? RenderMethodIcon(lastPayment?.method?.name)
                      : "-"}
                  </td>
                  <td>
                    {lastPayment
                      ? <b>{FormatMoney(lastPayment.amount_paid)}</b>
                      : "-"}
                  </td>
                  <td className="text-center">
                    {lastPayment
                      ? <span
                        className={`badge ${lastPayment?.status?.name?.toLowerCase() === "pago"
                            ? "bg-success"
                            : lastPayment?.status?.name?.toLowerCase() === "pendente"
                              ? "bg-warning"
                              : "bg-danger"
                          }`}
                      >
                        {lastPayment?.status?.name || "-"}
                      </span>
                      : "-"}
                  </td>
                  <td className="text-center">
                    {x?.start_date
                      ? moment(x.start_date).format("DD/MM/YYYY")
                      : "-"}
                  </td>
                  <td className="text-center">
                    {x?.end_date
                      ? moment(x.end_date).format("DD/MM/YYYY")
                      : "-"}
                  </td>
                  <td className="text-center">
                    {x?.created_at
                      ? moment(x.created_at).format("DD/MM/YYYY HH:mm:ss")
                      : "-"}
                  </td>
                  <td className="text-center">
                    <span
                      className={
                        !x?.deleted_at
                          ? "badge bg-success"
                          : "badge bg-danger"
                      }
                    >
                      {!x?.deleted_at ? "ATIVO" : "INATIVO"}
                    </span>
                  </td>
                  <td>{x?.stripe_subscription_id}</td>
                  <td className="text-center">
                    <DropdownMenuTable key={x.id}>
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleView(x)}
                      >
                        <FontAwesomeIcon icon={faEye} className="me-2" /> Visualizar
                      </Dropdown.Item>
                    </DropdownMenuTable>
                  </td>
                </tr>
              );
            })}
          </>
        ) : (
          <tr>
            <td colSpan={13} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Plano
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Tipo
                    </th>
                    <th
                      className="text-uppercase opacity-7"
                      scope="col"
                    >
                      Método
                    </th>
                    <th
                      className="text-uppercase opacity-7"
                      scope="col"
                    >
                      Valor
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status Pgto
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data início
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data fim
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data contratação
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7"
                      scope="col"
                    >
                      Id Stripe
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {subscriptions?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    setParams({ page: 1, perPage: 10, withPaginate: true, filter: { only_active: false } });
  }, []);

  return (
    <MasterPage title="Assinaturas" icon="fas fa-file-signature" footerFixed>
      <div className="Subscriptions" data-testid="Subscriptions">
        <PageBase
          title="Assinaturas"
          subtitle="Gerenciamento de assinaturas ativas e não ativas"
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
        />
      </div>

      <SidebarSubscriptionsFilter />

      <ModalSubscriptionView
        show={showModalView}
        onClose={handleCloseModal}
        subscription={selectedSubscription}
      />
    </MasterPage>
  );
};

export default Subscriptions;
